<template>
  <div class="my-prospecting-sidebar">
    <p class="sidebar-title">
      {{ $t('my_prospecting') }}
    </p>

    <router-link
      v-if="$can('read', PERMISSIONS.PERSONAL_SPACE_DASHBOARD)"
      class="iconized"
      :class="{ 'router-link-exact-active': $route.name.startsWith('Dashboard') }"
      :to="{ path: '/my-prospecting/dashboard'}"
    >
      <svg-element
        icon="dashboard"
        class="icon-color"
        size="16"
      />
      <span class="link">
        {{ $t('dashboard') }}
      </span>
    </router-link>

    <a
      v-if="$can('read', PERMISSIONS.MY_PROSPECTING_MY_PROSPECTS)"
      class="iconized"

      :href="`${configuration.desk_v1_host}/my-prospecting/my-prospects`"
    >
      <svg-element
        icon="prospects"
        class="icon-color"
        size="16"
      />

      <span class="link">
        {{ $t('my_prospects') }}
      </span>
    </a>

    <a
      v-if="$can('read', PERMISSIONS.MY_PROSPECTING_SMART_SCORING)"
      class="iconized"
      :href="`${configuration.desk_v1_host}/my-prospecting/smart-prospect`"
    >
      <svg-element
        icon="trending-up"
        class="icon-color"
        size="16"
      />

      <span class="link">
        {{ $t('smart_scoring') }}
      </span>
    </a>

    <a
      v-if="can_access_manager_pages"
      class="iconized"
      :class="{
        'active-link': $route.path.startsWith('/my-prospecting/team-monitoring')
          || $route.path.startsWith('/my-prospecting/lists-monitoring')
      }"
      @click="toggleSubmenu('show_manually_acces_manager_submenu')"
    >
      <svg-element
        icon="settings"
        class="icon-color"
        size="16"
      />

      <span class="link">
        {{ $t('access_manager') }}
      </span>

      <span
        v-if="!show_acces_manager_submenu"
        class="chevron"
      >
        <svg-element
          icon="chevron-down"
          class="icon-color"
          size="16"
        />
      </span>

      <span
        v-if="show_acces_manager_submenu"
        class="chevron"
      >
        <svg-element
          icon="chevron-up"
          class="icon-color"
          size="16"
        />
      </span>
    </a>

    <nav
      v-if="show_acces_manager_submenu"
      class="sublinks"
    >
      <router-link
        class="sublinks-link"
        :class="{ 'router-link-exact-active': $route.name.startsWith('TeamMonitoring') }"
        :to="{ path: '/my-prospecting/team-monitoring'}"
      >
        <span class="link">
          {{ $t('team_follow_up') }}
        </span>
      </router-link>

      <router-link
        class="sublinks-link"
        :class="{ 'router-link-exact-active': $route.name === 'ListMonitoringPage' }"
        :to="{ path: '/my-prospecting/lists-monitoring'}"
      >
        <span class="link">
          {{ $t('prospecting_list') }}
        </span>
      </router-link>
    </nav>
  </div>
</template>

<script>
import configuration from '@/configurations';

import { mapActions, mapGetters } from 'vuex';

import { PERMISSIONS } from '@/constants';
import SvgElement from '@/components/elements/SvgElement.vue';

export default {
  name: 'MyProspectingSidebarElement',
  components: {
    SvgElement,
  },
  data: () => ({
    configuration,
    PERMISSIONS,
    show_manually_acces_manager_submenu: false,
  }),
  computed: {
    ...mapGetters({
      user_data: 'user/userData',
    }),
    show_acces_manager_submenu() {
      return this.show_manually_acces_manager_submenu
        || this.show_automatically_acces_manager_submenu;
    },
    show_automatically_acces_manager_submenu() {
      return [
        'TeamMonitoringPage',
        'ListMonitoringPage',
        'LicenseMonitoringPage',
      ].includes(this.$route.name);
    },
    can_access_manager_pages() {
      return this.user_data.is_organization_manager && this.$can('read', PERMISSIONS.MY_PROSPECTING_MANAGER_ACCESS);
    },
  },
  methods: {
    ...mapActions({
    }),
    toggleSubmenu(sub_menu) {
      this[sub_menu] = !this[sub_menu];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/constants/variables.module.scss';
.active-link {
  border-right: 3px solid $cornflower-blue !important;
  color: $haiti;

  svg {
    --color: #{$cornflower-blue} !important;
  }
}

.chevron {
    margin-left: 5px;
}

.icon-color {
  --color: #{$amethyst-smoke};
}

.iconized {
  align-items: center;
  border: none;
  color: $amethyst-smoke;
  display: flex;
  font-weight: 500;
  gap: 12px;
  height: 16px;
  letter-spacing: 0;
  line-height: 16px;
  margin-bottom: 16px;
  outline: none;
  text-decoration: none;

  &:hover {
    border-right: 3px solid $cornflower-blue;
    color: $haiti;

    svg {
      --color: #{$cornflower-blue} !important;
    }
  }
}

.link {
  font-family: 'DM Sans', sans-serif;
}

.my-prospecting-sidebar {
}

.router-link-exact-active {
  border-right: 3px solid $cornflower-blue !important;
  color: $haiti !important;
  svg {
  --color: #{$cornflower-blue} !important;
  }
}

.sidebar-title {
  color: $blue-haze;
  font-family: 'DM Sans', sans-serif;
  height: 12px;
  margin: 20px 0 16px 0;
  letter-spacing: 2px;
  line-height: 12px;
  text-transform: uppercase;
}

.sublinks {
  border-left: 1px solid $amethyst-smoke;
  margin-left: 28px;
  margin-bottom: 16px;
  padding-left: 20px;
}

.sublinks-link {
  align-items: center;
  border: none;
  color: $amethyst-smoke;
  display: flex;
  font-weight: 500;
  height: 16px;
  letter-spacing: 0;
  line-height: 16px;
  margin-bottom: 16px;
  outline: none;
  text-decoration: none;

  &:hover {
    color: $haiti;
  }
}
</style>

<i18n src="@/locales/common.json"></i18n>

<i18n src="@/locales/components/elements/my-prospecting-sidebar-element.json"></i18n>
